	import { Component,  BaseTLDetailComponent, AxiosResponse } from "../../../Infrastructure/CorBase/CoreBase";
import { PricelistTemplateService, PricelistTemplateFilter } from "../../../Services/AccBase/AllAccServices";

	export default abstract class  PricelistTemplateDetailBase extends BaseTLDetailComponent {

		pricelistTemplateService: PricelistTemplateService = new PricelistTemplateService();

		formData = {
			id: 0,
			name: '',
			description: '',
			identifier: '',
			vat: '',
			isDaily: false,
			isFromTo: false,
			idTariff: 0,
			idTariffName: '',
			idItemType: 0,
			priceDay: 0,
			priceMonth: 0,
			amount: 0,
			amountFrom: 0,
			amountTo: 0,
			unit: '',
			isDeleted: false
		};

		protected doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('pricelistTemplate.messageNew').toString(), this.$t('pricelistTemplate.messageEdit').toString(), this.$t('pricelistTemplate.messageDelete').toString());
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.pricelistTemplateService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.name = response.data.name;
			this.formData.description = response.data.description;

			this.formData.identifier = response.data.identifier;
			this.formData.vat = response.data.vat;
			this.formData.idTariff = response.data.idTariff;
			this.formData.idTariffName = response.data.idTariffName;
			this.formData.idItemType = response.data.idItemType;
			this.formData.priceDay = response.data.priceDay;
			this.formData.priceMonth = response.data.priceMonth;
			this.formData.amount = response.data.amount;
			this.formData.amountFrom = response.data.amountFrom;
			this.formData.amountTo = response.data.amountTo;
			this.formData.unit = response.data.unit;

			this.formData.isDaily = this.formData.priceDay > 0;
			this.formData.isFromTo = this.formData.amount == 0;


		}

		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			if (this.formData.isDaily) {
				this.formData.priceMonth = 0;
			}
			else {
				this.formData.priceDay = 0;
			}

			if (this.formData.isFromTo) {
				this.formData.amount = 0;
			}
			else {
				this.formData.amountFrom = 0;
				this.formData.amountTo = 0;
			}
			return this.pricelistTemplateService.update(this.objectId, this.formData)
		}

		updateBase() {
			if (this.formData.isDaily) {
				this.formData.priceMonth = 0;
			}
			else {
				this.formData.priceDay = 0;
			}

			if (this.formData.isFromTo) {
				this.formData.amount = 0;
			}
			else {
				this.formData.amountFrom = 0;
				this.formData.amountTo = 0;
			}
		 this.pricelistTemplateService.update(this.objectId, this.formData).then(res => {
				if (res.data.isSuccess == false) {
					this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), res.data.errorMessage);
				}
				else {
					this.showAlertModalWithInfoMessage(this.$t('pricelistTemplate.messageEdit').toString());
					this.formIsInEditMode = false;
					//	this.styleFormDetail = false;
				}
			});
		}

		protected createObject(): Promise<AxiosResponse<any>> {		
			
			return this.pricelistTemplateService.create(this.formData);
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.pricelistTemplateService.delete(this.objectId);
		}
		
		vIsCorrectName: boolean = true;
		vIsCorrectIdentifier: boolean = true;
		vIsCorrectVat: boolean = true;
		vIsCorrectUnit: boolean = true;

		vIsCorrectDaily: boolean = true;
		vIsCorrectMonthly: boolean = true;

		vIsCorrectAmount: boolean = true;
		vIsCorrectAmountTo: boolean = true;
		vIsCorrectAmountFrom: boolean = true;
	
		protected validateBase() {
			return !(this.vIsCorrectName && this.vIsCorrectIdentifier && this.vIsCorrectVat && this.vIsCorrectUnit && ((this.formData.isDaily && this.vIsCorrectDaily) || (!this.formData.isDaily && this.vIsCorrectMonthly))
				&& ((!this.formData.isFromTo && this.vIsCorrectAmount) || (this.formData.isFromTo && this.vIsCorrectAmountFrom && this.vIsCorrectAmountTo))


			);
		}
		
		protected isCorrectNameBase(value: any) {
			this.vIsCorrectName = value;
		}

		protected isCorrectIdentifierBase(value: any) {
			this.vIsCorrectIdentifier = value;
		}

		protected isCorrectVarBase(value: any) {
			this.vIsCorrectVat = value;
		}

		protected isCorrectUnitBase(value: any) {
			this.vIsCorrectUnit = value;
		}

		protected isCorrectDailyBase(value: any) {
			this.vIsCorrectDaily = value;
		}

		protected isCorrectMonthlyBase(value: any) {
			this.vIsCorrectMonthly = value;
		}

		protected isCorrectAmountBase(value: any) {
			this.vIsCorrectAmount = value;
		}
		protected isCorrectAmountToBase(value: any) {
			this.vIsCorrectAmountTo = value;
		}
		protected isCorrectAmountFromBase(value: any) {
			this.vIsCorrectAmountFrom = value;
		}
	
	}
